import React from 'react';
import './index.scss';
import _ from 'lodash';
import { GTM_APP_STORE_BADGE_CTA_CLICK } from '../../../constants/defaults';
import { withTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const AppsLinkRating = props => {
  const { t } = props;
  const sendGTMEvent = storeType => {
    _.triggerGTMVirtualPageViewEvent({
      event: GTM_APP_STORE_BADGE_CTA_CLICK,
      store_type: `${storeType} store`,
      device_type: _.getIsMobileDevice() ? 'mobile' : 'desktop',
      formId: 'mobile-app',
      clickText: storeType === 'app' ? 'App Store' : 'Google Play',
      location: props.isFromFooter ? 'footer' : 'body'
    });
  };
  return (
    <div>
      <div className="ratingWrap">
        <img
          src="/content/images/apps/rating-yellow.svg"
          height="12"
          width="70"
          alt=""
        />
        <span>4.8 average rating</span>
      </div>
      <div className="applinkWrap d-flex">
        <a
          href="https://singlecare.onelink.me/OxIQ/f9kgy50o"
          target="_blank"
          onClick={() => sendGTMEvent('app')}
          rel="noreferrer"
          aria-label="SingleCare iOS App"
        >
          <LazyLoadImage
            src="/content/images/apps/app-store.svg"
            height={43}
            width={140}
            alt={t('App Store footer')}
          />
        </a>
        <a
          href="https://singlecare.onelink.me/OxIQ/ulxga0z3"
          target="_blank"
          onClick={() => sendGTMEvent('play')}
          rel="noreferrer"
          aria-label="SingleCare Android App"
        >
          <LazyLoadImage
            src="/content/images/apps/google-play.svg"
            height={43}
            width={140}
            alt={t('Google play')}
          />
        </a>
      </div>
    </div>
  );
};

export default withTranslation()(AppsLinkRating);
